module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "width": "75%",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "出库单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.StockOutCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentCode) + " " + _vm._s(_vm.Form.AgentName) + " " + _vm._s(_vm.Form.AgentAddress) + " " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "实际发货时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.StockOutTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "实际签收时间"
    }
  }, [(_vm.Form.SignTime != '' && _vm.Form.SignTime != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.SignTime))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderTypeShow),
      expression: "orderTypeShow"
    }]
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "申请时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.ApplyTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "期望上课日期"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.StartDate))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "园所名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SchoolName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "课程名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderTitle))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "幼儿数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Attendance))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开课申请表:"
    }
  }, [(JSON.stringify(_vm.Form.ApplicationForm) != '[]') ? _c('el-row', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, _vm._l((_vm.Form.ApplicationForm), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin-right": "25px",
        "margin-top": "10px"
      },
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "border": "4px solid RGB(205,205,205)",
        "border-radius": "3px",
        "line-height": "0px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "display": "block"
      },
      attrs: {
        "src": item.Url
      },
      on: {
        "click": function($event) {
          _vm.viewpic(item.Url)
        }
      }
    })])])
  })) : _c('span', [_vm._v("--")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "发货通知单发货情况"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.DeliveryStatusName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.PackageName != ''),
      expression: "Form.PackageName!=''"
    }],
    staticClass: "edit-form",
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PackageName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ListGoods != ''),
      expression: "Form.ListGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.ListGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "实发"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReceiveNum",
      "label": "实收"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.GiftGoods != ''),
      expression: "Form.GiftGoods!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.GiftGoods,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包含单品",
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PackDetail.length == 0) ? _c('div', [_vm._v("--")]) : _c('div', {
          staticClass: "dpDvCtnCss"
        }, _vm._l((scope.row.PackDetail), function(PackDetail) {
          return _c('div', {
            staticClass: "dpDvCss"
          }, [_vm._v(_vm._s(PackDetail.ProName))])
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "NeedSendNum",
      "label": "应发数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "实发"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ReceiveNum",
      "label": "实收"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "签收凭证"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.Form.ReceiptPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + "--" + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "快递或物流名称"
    }
  }, [(_vm.Form.LogisticsName != '' && _vm.Form.LogisticsName != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.LogisticsName))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "快递或物流单号"
    }
  }, [(_vm.Form.LogisticsCode != '' && _vm.Form.LogisticsCode != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.LogisticsCode))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "包裹件数"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PackageNum))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "出库单备注"
    }
  }, [(_vm.Form.Remark != '' && _vm.Form.Remark != undefined) ? _c('span', [_vm._v(_vm._s(_vm.Form.Remark))]) : _c('span', [_vm._v("--")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("我知道了")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "picshow"
  }, [_c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.picVisible),
      callback: function($$v) {
        _vm.picVisible = $$v
      },
      expression: "picVisible"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.picUrl,
      "alt": ""
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f6724772!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StockOut/VStockOut.vue
// module id = 1584
// module chunks = 1